function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h24v24H0z"
}), React.createElement("path", {
  fill: "#102E8E",
  d: "M14 4v1c0 1.362.688 2.496 1.571 3.398.908.926 2.384 1.609 3.784 1.609h.028L18.3 11.97c-.34.62-1 1.03-1.75 1.03H9.1l-.9 1.63-.03.12c0 .14.11.25.25.25H20v2H8c-1.1 0-2-.9-2-2 0-.35.09-.68.25-.96l1.35-2.45L4 4H2V2h3.27l.94 2H14zM8 18c1.1 0 2 .9 2 2s-.9 2-2 2-1.99-.9-1.99-2S6.9 18 8 18zm10 0c1.1 0 2 .9 2 2s-.9 2-2 2-1.99-.9-1.99-2 .89-2 1.99-2z"
}), React.createElement("circle", {
  cx: 20,
  cy: 4,
  r: 4,
  fill: "#FF6230"
}));

var SvgIcShoppingCartAdded = function SvgIcShoppingCartAdded(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiMxMDJFOEUiIGQ9Ik0xNCA0djFjMCAxLjM2Mi42ODggMi40OTYgMS41NzEgMy4zOTguOTA4LjkyNiAyLjM4NCAxLjYwOSAzLjc4NCAxLjYwOWguMDI4TDE4LjMgMTEuOTdjLS4zNC42Mi0xIDEuMDMtMS43NSAxLjAzSDkuMWwtLjkgMS42My0uMDMuMTJjMCAuMTQuMTEuMjUuMjUuMjVIMjB2Mkg4Yy0xLjEgMC0yLS45LTItMiAwLS4zNS4wOS0uNjguMjUtLjk2bDEuMzUtMi40NUw0IDRIMlYyaDMuMjdsLjk0IDJIMTR6TTggMThjMS4xIDAgMiAuOSAyIDJzLS45IDItMiAyLTEuOTktLjktMS45OS0yUzYuOSAxOCA4IDE4em0xMCAwYzEuMSAwIDIgLjkgMiAycy0uOSAyLTIgMi0xLjk5LS45LTEuOTktMiAuODktMiAxLjk5LTJ6Ii8+CiAgICAgICAgPGNpcmNsZSBjeD0iMjAiIGN5PSI0IiByPSI0IiBmaWxsPSIjRkY2MjMwIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgIcShoppingCartAdded as ReactComponent };